<template>
  <Toaster
    position="top-right"
    :closeButton="true"
    :duration="3000"
    :theme="isDark ? 'dark' : 'light'"
  />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { Toaster } from "vue-sonner";

const isDark = ref(false);

function readTheme() {
  if (typeof document === "undefined") return false;
  return document.documentElement.classList.contains("dark");
}

let themeObserver = null;

onMounted(() => {
  isDark.value = readTheme();
  themeObserver = new MutationObserver(() => {
    isDark.value = readTheme();
  });
  themeObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
});

onBeforeUnmount(() => {
  if (themeObserver) themeObserver.disconnect();
});
</script>

<style>
[data-sonner-toast][data-styled="true"]:has(> [data-button][data-action]) {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  column-gap: 12px;
  row-gap: 6px;
}

[data-sonner-toast][data-styled="true"] > [data-icon] {
  grid-column: 1;
  grid-row: 1;
  margin: 0;
}

[data-sonner-toast][data-styled="true"] > [data-content] {
  grid-column: 2;
  grid-row: 1;
}

[data-sonner-toast][data-styled="true"] > [data-button][data-action] {
  display: none;
  grid-column: 1 / -1;
  grid-row: 2;
  justify-self: end;
  width: auto;
  height: auto;
  margin: 0;
  padding: 4px 10px;
  border: none;
  border-radius: 6px;
  box-shadow: none;
  background: transparent;
  color: var(--normal-text);
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

[data-sonner-toast][data-styled="true"] > [data-button][data-action]:hover {
  background: color-mix(in srgb, var(--normal-text) 8%, transparent);
}

[data-sonner-toast][data-styled="true"]:hover,
[data-sonner-toast][data-styled="true"]:focus-within {
  height: auto !important;
}

[data-sonner-toast][data-styled="true"]:hover > [data-button][data-action],
[data-sonner-toast][data-styled="true"]:focus-within
  > [data-button][data-action] {
  display: inline-flex;
}
</style>
